// Compatibility shim kept while the app finishes migrating from
// react-router-dom v5 to v6. It holds the live router location so imperative,
// non-component code can read it without a hook. Fed by `useHistoryCompatible`.
class LocationClass {
  private location: any | null = null

  setLocation(newLocation: any) {
    this.location = newLocation
  }

  getLocation(): any | null {
    return this.location
  }
}

export const LocationCompatible = new LocationClass()
